import React, { useContext } from "react";
import { Redirect, RedirectProps } from "react-router-dom";

import { DialogNavigationContext, IDialogNavigationContext } from "ui/app/navigation/dialog";

const getRootDialogNavigationContext = (dialogNavigationContext: IDialogNavigationContext) => {
  let result: IDialogNavigationContext = dialogNavigationContext;

  if (dialogNavigationContext.parentContext) {
    result = getRootDialogNavigationContext(dialogNavigationContext.parentContext);
  }

  return result;
};

export const AppRedirect: React.FC<RedirectProps> = ({ ...props }) => {
  const dialogNavigationContext = useContext(DialogNavigationContext);

  const rootDialogNavigationContext = getRootDialogNavigationContext(dialogNavigationContext);
  rootDialogNavigationContext.hideDialog();

  return <Redirect {...props} />;
};
